// Shopify integration service for connection

// Connect to Shopify
export async function connectShopify(shopDomain: string): Promise<{ success: boolean; error?: string }> {
  // Simulate API call
  await new Promise((resolve) => setTimeout(resolve, 1500));

  if (shopDomain.includes(".myshopify.com")) {
    localStorage.setItem("shopify_connected", "true");
    localStorage.setItem("shopify_domain", shopDomain);
    return { success: true };
  }

  return {
    success: false,
    error: "Invalid Shopify domain. Please use format: yourstore.myshopify.com",
  };
}
